import { jsx as _jsx } from "react/jsx-runtime";
import Layout from "@/components/Layout";
import { Box, Container } from "@mui/material";
import { useState } from "react";
import KnowledgeBaseList from "@/components/KnowledgeBaseList";
import useAppBarHeight from "@/hooks/useAppBarHeight";
import { useSessionContext } from "@/contexts/SessionContext";
export default (function () {
    var appBarHeight = useAppBarHeight();
    var zoomContext = useSessionContext().zoomContext;
    var _a = useState(false), exploreKB = _a[0], setExploreKB = _a[1];
    console.log("zoomContext", zoomContext);
    return (_jsx(Layout, { children: _jsx(Box, { sx: { pt: "".concat(appBarHeight + 22, "px"), pb: "".concat(appBarHeight + 22, "px"), width: '100%' }, children: _jsx(Container, { maxWidth: false, children: _jsx(KnowledgeBaseList, {}) }) }) }));
});
